/**
 * Screen 07's own calls. The shared client in `../api.ts` covers the library
 * and the venue state; sales are fetched here so the venue state route stays
 * unchanged and a POS sync does not invalidate what every other screen reads.
 */

import type { SalesRecord } from "@baros/core";
import { request as shared } from "../api.js";

async function request<T>(
  token: string,
  method: "GET" | "PUT",
  path: string,
  body?: unknown,
): Promise<T> {
  // The shared client: it refreshes an expired token once and ends
  // the session when it cannot (see `request` in src/api.ts).
  return shared<T>(token, method, path, body);
}

/** What a manager may set: everything else on the row is the server's. */
export interface SalesUpdate {
  readonly unitsPerWeek: number;
  readonly source?: "manual" | "pos";
  readonly periodStart?: string;
}

export const menuApi = {
  sales: (token: string, venueId: string) =>
    request<{ sales: SalesRecord[] }>(
      token,
      "GET",
      `/v1/venues/${encodeURIComponent(venueId)}/sales`,
    ),
  saveSales: (token: string, venueId: string, specId: string, body: SalesUpdate) =>
    request<{ sale: SalesRecord }>(
      token,
      "PUT",
      `/v1/venues/${encodeURIComponent(venueId)}/sales/${encodeURIComponent(specId)}`,
      body,
    ),
};
